import {
  EMAIL_CHANGE_CALLBACK_ERROR_PARAM,
  EMAIL_CHANGE_CALLBACK_PARAM,
  EmailChangeCallbackResult,
  parseEmailChangeCallback,
} from '@rentguru/commons-utils';
import { toastWithVariant } from '@up2rent/ui-new';
import isNil from 'lodash/isNil';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { getEmailChangeCallbackFeedback } from 'src/utils/emailChangeUtils';

const EMAIL_CHANGE_FEEDBACK_DURATION_MS = 12000;

const removeEmailChangeCallbackParams = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete(EMAIL_CHANGE_CALLBACK_PARAM);
  url.searchParams.delete(EMAIL_CHANGE_CALLBACK_ERROR_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

export const useEmailChangeCallbackFeedback = () => {
  const { formatMessage } = useIntl();
  // Read during the first render: a signed-out visitor is redirected to the login screen, which drops the query.
  const [callbackResult] = useState<EmailChangeCallbackResult | undefined>(() =>
    parseEmailChangeCallback(window.location.search)
  );

  useEffect(() => {
    if (isNil(callbackResult)) {
      return;
    }
    const { messageId, variant } = getEmailChangeCallbackFeedback(callbackResult);
    toastWithVariant(variant, formatMessage({ id: messageId }), { duration: EMAIL_CHANGE_FEEDBACK_DURATION_MS });
    removeEmailChangeCallbackParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callbackResult]);
};
